import React from 'react';
import AppNavbar from '@/AppNavbar';
import EventbuizzFooter from '../../EventbuizzFooter';
const DashboardLayout = ({ children, ...rest }) => {
    return (
        <div id="App" className="inner-pages">
            <AppNavbar />
            <main role="main" className="main-section">
                <div className="container">
                    <div className="wrapper-box">
                        {children}
                    </div>
                </div>
            </main>
            <div className="fixed-bottom">
                <EventbuizzFooter />
            </div>
        </div>
    )
}

const DashboardLayoutRoute = ({ children, ...rest }) => {
    return (
        <DashboardLayout>
            {children}
        </DashboardLayout>
    )
};

export default DashboardLayoutRoute;